import React from "react";
import { isMobile } from "react-device-detect";
import { Container, Grid } from "semantic-ui-react";

function LocationGroups() {
  const renderGroup = (item) => (
    <div className="group-item-wrapper">
      <a href={item.link}>
        <div className="group-item">
          <img alt="Sliea" rounded src={item.img} style={styles.image} />
          <div className="group-item-title">{item.title}</div>
        </div>
      </a>
      <div style={{ marginTop: 10 }}>
        <Grid columns={4} container>
          {item.cities.map((city, i) => (
            <Grid.Column
              className="city"
              textAlign={"left"}
              key={"city-" + city.name + "-" + i}
              href={city.link}
            >
              {city.name}
            </Grid.Column>
          ))}
        </Grid>
      </div>
    </div>
  );

  return (
    <Container
      style={{ textAlign: "center", marginTop: "2vh", color: "#353a47" }}
    >
      <h1 className="pc-title">Best Locations In Malta</h1>

      <Grid>
        <Grid.Row columns={isMobile ? 1 : 3}>
          <Grid.Column>{renderGroup(centralMalta)}</Grid.Column>
          {isMobile ? <div style={{ height: "2rem", width: "10px" }} /> : null}
          <Grid.Column>{renderGroup(sliema)}</Grid.Column>
          {isMobile ? <div style={{ height: "2rem", width: "10px" }} /> : null}
          <Grid.Column>{renderGroup(southMalta)}</Grid.Column>
        </Grid.Row>
        <Grid.Row columns={isMobile ? 1 : 2}>
          {isMobile ? <div style={{ height: "2rem", width: "10px" }} /> : null}
          <Grid.Column>{renderGroup(northMalta)}</Grid.Column>

          {isMobile ? <div style={{ height: "2rem", width: "10px" }} /> : null}
          <Grid.Column>{renderGroup(gozo)}</Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  );
}

export default LocationGroups;

const styles = {
  image: {
    width: "100%",
    height: 200,
    objectFit: "cover",
    borderRadius: "5px",
  },
};

const centralMalta = {
  title: "Central Malta",
  img: "/img/home/central.jpeg",
  link: "https://www.easysale.com.mt/property-for-sale-in-cental-malta",
  cities: [
    {
      name: "Attard",
      link: "https://easysale.com.mt/property-for-sale-in-attard",
    },
    {
      name: "Balzan",
      link: "https://easysale.com.mt/property-for-sale-in-balzan",
    },
    {
      name: "Bidnija",
      link: "https://easysale.com.mt/property-for-sale-in-bidnija",
    },
    {
      name: "Birguma",
      link: "https://easysale.com.mt/property-for-sale-in-birguma",
    },
    {
      name: "Birkirkara",
      link: "https://easysale.com.mt/property-for-sale-in-birkirkara",
    },
    {
      name: "Dingli",
      link: "https://easysale.com.mt/property-for-sale-in-dingli",
    },
    {
      name: "Gharghur",
      link: "https://easysale.com.mt/property-for-sale-in-gharghur",
    },
    {
      name: "Iklin",
      link: "https://easysale.com.mt/property-for-sale-in-iklin",
    },
    {
      name: "Lija",
      link: "https://easysale.com.mt/property-for-sale-in-lija",
    },
    {
      name: "Mdina",
      link: "https://easysale.com.mt/property-for-sale-in-mdina",
    },
    {
      name: "Mosta",
      link: "https://easysale.com.mt/property-for-sale-in-mosta",
    },
    {
      name: "Mriehel",
      link: "https://easysale.com.mt/property-for-sale-in-mriehel",
    },
  ],
};

const sliema = {
  title: "Sliema",
  img: "/img/home/sliema.jpeg",
  link: "https://www.easysale.com.mt/property-for-sale-in-sliema",
  cities: [
    {
      name: "Bahar ic-Caghaq",
      link: "https://easysale.com.mt/property-for-sale-in-bahar-ic-caghaq",
    },
    {
      name: "Floriana",
      link: "https://easysale.com.mt/property-for-sale-in-floriana",
    },
    {
      name: "Gzira",
      link: "https://easysale.com.mt/property-for-sale-in-gzira",
    },
    {
      name: "Hamrun",
      link: "https://easysale.com.mt/property-for-sale-in-hamrun",
    },
    {
      name: "High Ridge",
      link: "https://easysale.com.mt/property-for-sale-in-high-ridge",
    },
    {
      name: "Kappara",
      link: "https://easysale.com.mt/property-for-sale-in-kappara",
    },
    {
      name: "Madliena",
      link: "https://easysale.com.mt/property-for-sale-in-madliena",
    },
    {
      name: "Msida",
      link: "https://easysale.com.mt/property-for-sale-in-msida",
    },
    {
      name: "Paceville",
      link: "https://easysale.com.mt/property-for-sale-in-paceville",
    },
    {
      name: "Pembroke",
      link: "https://easysale.com.mt/property-for-sale-in-pembroke",
    },
    {
      name: "Pieta",
      link: "https://easysale.com.mt/property-for-sale-in-pieta",
    },
    {
      name: "San Gwann",
      link: "https://easysale.com.mt/property-for-sale-in-san-gwann",
    },
  ],
};

const southMalta = {
  title: "South Malta",
  img: "/img/home/south-malta.jpeg",
  link: "https://easysale.com.mt/property-for-sale-in-south-malta",
  cities: [
    {
      name: "Birgu",
      link: "https://easysale.com.mt/property-for-sale-in-birgu",
    },
    {
      name: "Birzebbuga",
      link: "https://easysale.com.mt/property-for-sale-in-birzebbuga",
    },
    {
      name: "Bormla",
      link: "https://easysale.com.mt/property-for-sale-in-bormla",
    },
    {
      name: "Cospicua",
      link: "https://easysale.com.mt/property-for-sale-in-cospicua",
    },
    {
      name: "Fgura",
      link: "https://easysale.com.mt/property-for-sale-in-fgura",
    },
    {
      name: "Ghaxaq",
      link: "https://easysale.com.mt/property-for-sale-in-ghaxaq",
    },
    {
      name: "Gudja",
      link: "https://easysale.com.mt/property-for-sale-in-gudja",
    },
    {
      name: "Isla",
      link: "https://easysale.com.mt/property-for-sale-in-isla",
    },
    {
      name: "Kalkara",
      link: "https://easysale.com.mt/property-for-sale-in-kalkara",
    },
    {
      name: "Kirkop",
      link: "https://easysale.com.mt/property-for-sale-in-kirkop",
    },
    {
      name: "Luqa",
      link: "https://easysale.com.mt/property-for-sale-in-luqa",
    },
    {
      name: "Marsa",
      link: "https://easysale.com.mt/property-for-sale-in-marsa",
    },
  ],
};

const northMalta = {
  title: "North Malta",
  img: "/img/home/north-malta.jpeg",
  link: "https://easysale.com.mt/property-for-sale-in-north-malta",
  cities: [
    {
      name: "Bahrija",
      link: "https://easysale.com.mt/property-for-sale-in-bahrija",
    },
    {
      name: "Bugibba",
      link: "https://easysale.com.mt/property-for-sale-in-bugibba",
    },
    {
      name: "Burmarrad",
      link: "https://easysale.com.mt/property-for-sale-in-burmarrad",
    },
    {
      name: "Ghadira",
      link: "https://easysale.com.mt/property-for-sale-in-ghadira",
    },
    {
      name: "Manikata",
      link: "https://easysale.com.mt/property-for-sale-in-manikata",
    },
    {
      name: "Mellieha",
      link: "https://easysale.com.mt/property-for-sale-in-mellieha",
    },
    {
      name: "Mgarr",
      link: "https://easysale.com.mt/property-for-sale-in-mgarr",
    },
    {
      name: "Qawra",
      link: "https://easysale.com.mt/property-for-sale-in-qawra",
    },
    {
      name: "Salina",
      link: "https://easysale.com.mt/property-for-sale-in-salina",
    },
    {
      name: "St Pauls Bay",
      link: "https://easysale.com.mt/property-for-sale-in-st-pauls-bay",
    },
    {
      name: "Wardija",
      link: "https://easysale.com.mt/property-for-sale-in-wardija",
    },
    {
      name: "Xemxija",
      link: "https://easysale.com.mt/property-for-sale-in-xemxija",
    },
  ],
};

const gozo = {
  title: "Gozo",
  img: "/img/home/gozo.jpeg",
  link: "https://www.easysale.com.mt/property-for-sale-in-gozo",
  cities: [
    {
      name: "Xaghra",
      link: "https://easysale.com.mt/property-for-sale-in-xaghra",
    },
    {
      name: "Fontana",
      link: "https://easysale.com.mt/property-for-sale-in-fontana",
    },
    {
      name: "Ghajnsielem",
      link: "https://easysale.com.mt/property-for-sale-in-ghajnsielem",
    },
    {
      name: "Gharb",
      link: "https://easysale.com.mt/property-for-sale-in-gharb",
    },
    {
      name: "Ghasri",
      link: "https://easysale.com.mt/property-for-sale-in-ghasri",
    },
    {
      name: "Kercem",
      link: "https://easysale.com.mt/property-for-sale-in-ercem",
    },
    {
      name: "Marsalforn",
      link: "https://easysale.com.mt/property-for-sale-in-marsalforn",
    },
    {
      name: "Munxar",
      link: "https://easysale.com.mt/property-for-sale-in-munxar",
    },
    {
      name: "Nadur",
      link: "https://easysale.com.mt/property-for-sale-in-nadur",
    },
    {
      name: "Qala",
      link: "https://easysale.com.mt/property-for-sale-in-qala",
    },
    {
      name: "Rabat (Victoria)",
      link: "https://easysale.com.mt/property-for-sale-in-rabat",
    },
    {
      name: "San Lawrenz",
      link: "https://easysale.com.mt/property-for-sale-in-san-lawrenz",
    },
  ],
};
